import Vue from 'vue';
import Router from 'vue-router';

import Login from './views/auth/Login';
import ForgotPassword from './views/auth/ForgotPassword';
import Admin from './views/admin/Admin';
import ResetPassword from './views/auth/ResetPassword';


import Dashboard from './views/dashboard/Dashboard';
import Profile from './views/dashboard/Profile';

// quotations
import Quotations from "./views/quotations/Quotations";
import DraftQuotation from './views/quotations/DraftQuotation';
import NewQuotation from "./views/quotations/NewQuotation";
import QuotationShow from "./views/quotations/QuotationShow";
import PriceCalculation from "./views/quotations/PriceCalculation";
import SendQuoteCustomer from "./views/quotations/SendQuoteCustomer";
import QuoteSentCustomer from "./views/quotations/QuoteSentCustomer";

//customers
import CustomerList from './views/customers/CustomerList';
import CustomerAdd from './views/customers/CustomerAdd';
import CustomerEdit from './views/customers/CustomerEdit';
import CustomerView from './views/customers/CustomerView';

//vendors
import VendorList from './views/vendors/VendorList';
import VendorAdd from './views/vendors/VendorAdd';
import VendorEdit from './views/vendors/VendorEdit';
import VendorView from './views/vendors/VendorView';

//tasks
import TaskAdd from './views/tasks/TaskAdd';
import TaskList from './views/tasks/TaskList';
import TaskView from './views/tasks/TaskView';
import TaskEdit from './views/tasks/TaskEdit';
import Tasks from './views/tasks/Tasks';

// settings
import UserList from './views/settings/UserList';
import UserPermission from './views/settings/UserPermission';
import TaskPriority from './views/settings/TaskPriority';
//Quotation Status
import QuotationStatus from './views/settings/QuotationStatus/QuotationStatusList';
import QuotationStatusAdd from './views/settings/QuotationStatus/add';
import QuotationStatusEdit from './views/settings/QuotationStatus/edit';
//Vendor Bags
import VendorBag from './views/settings/VendorBag/VendorBagList';
import VendorBagAdd from './views/settings/VendorBag/add';
import VendorBagEdit from './views/settings/VendorBag/edit';

//Sales Rep
import SalesRep from './views/settings/SalesRep/SalesRepList';
import SalesRepAdd from './views/settings/SalesRep/add';
import SalesRepEdit from './views/settings/SalesRep/edit';

import GlobalSettings from './views/settings/GlobalSettings';
import NotificationSettings from './views/settings/NotificationSettings';
import UserRole from './views/settings/UserRole';

import AddOrder from "./views/orders/AddOrder";
import SelectCustomer from "./views/orders/SelectCustomer";
import SelectQuotes from "./views/orders/SelectQuotes";
import SelectProducts from "./views/orders/SelectProducts";
import ProvideOtherInfo from "./views/orders/ProvideOtherInfo";
import Orders from "./views/orders/Orders";
import DraftOrders from "./views/orders/DraftOrders";
//ProductsEdit
import ProductsList from './views/products/ProductList';
import ProductsAdd from './views/products/ProductAdd';
import ProductsEdit from './views/products/ProductEdit';
import ProductsView from './views/products/ProductView';
import PurchaseOrders from "./views/purchase-orders/PurchaseOrders";
import AddPurchaseOrder from "./views/purchase-orders/AddPurchaseOrder";
import PurchaseSelectVendor from "./views/purchase-orders/PurchaseSelectVendor";
import PurchaseSelectProducts from "./views/purchase-orders/PurchaseSelectProducts";
import PurchaseProvideOtherInfo from "./views/purchase-orders/PurchaseProvideOtherInfo";
import PurchaseOrderShow from "./views/purchase-orders/PurchaseOrderShow";
import purchaseOrderShowShipment from "./views/purchase-orders/purchaseOrderShowShipment";


import Order from "./views/orders/Order";
import DraftPurchaseOrders from "./views/purchase-orders/DraftPurchaseOrders";
import Artworks from "./views/artworks/Artworks";
import OrderSignature from "./views/orders/OrderSignature";
import TaskWorkflows from "./views/tasks/TaskWorkflows";
import Reminders from "./views/tasks/Reminders";
import DefaultGlobalSettings from "./views/settings/DefaultGlobalSettings";
import Labels from "./views/settings/Labels";
// Report Vue
import SalesReport from "./views/reports/sales-repots";
import Shipments from "./views/shipments/shipment";

// Warehouse
import WarehouseList from './views/warehouse/WarehouseList';
import WarehouseEdit from './views/warehouse/WarehouseEdit';

window.popStateDetected = false
window.addEventListener('popstate', () => {
    window.popStateDetected = true
});

Vue.use(Router);


let router = new Router({
    //mode: 'hash', // https://router.vuejs.org/api/#mode
    mode: 'history',
    base: process.env.BASE_URL,
    linkActiveClass: 'active',
    scrollBehavior: () => ({ y: 0 }),
    routes: configRoutes()
});


let isAuthenticated = function (){
    let auth = localStorage.getItem("auth");
    return typeof auth != undefined && auth != 'undefined' && auth != null;
};

router.beforeEach((to, from, next) => {
    /*const IsItABackButton = window.popStateDetected
    window.popStateDetected = false
    if (IsItABackButton && from.meta.someLogica) {
        next(false)
        return ''
    }*/

    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (isAuthenticated()) {
            next()
            return
        }
        next({name: 'login'})
    } else if(to.matched.some((record) => record.meta.login)) {
        if (isAuthenticated()) {
            next({name: 'dashboard'})
        }



    }
    next()
});

export default router;

function configRoutes() {
    return [
        {
            path: '/',
            name: 'login',
            component: Login,
            meta: {
                requiresAuth: false,
                login: true
            },
        },
        {
            path: '/password/reset',
            name: 'ForgotPassword',
            component: ForgotPassword,
            meta: {
                requiresAuth: false
            },
        },
         {
            path: '/login/reset/:id',
            name: 'loginReset',
            component: ResetPassword,
            meta: {
                requiresAuth: false,
                login: true
            },
        },
        {
            path: '/artworks/:artwork_id',
            name: 'singleArtwork',
            component: Artworks,
            meta: {
                requiresAuth: false
            },
        },
        {
            path: '/orders/:id/artworks/:method_id',
            name: 'allArtworksMethod1',
            component: Artworks,
            meta: {
                requiresAuth: false
            },
        },
        {
            path: '/orders/:id/artworks',
            name: 'allArtworks',
            component: Artworks,
            meta: {
                requiresAuth: false
            },
        },
        {
            path: '/orders/:id/products/:product_id/artworks/:artwork_id',
            name: 'artwork',
            component: Artworks,
            meta: {
                requiresAuth: false
            },
        },
        {
            path: '/orders/:id/sign/:customer_id',
            name: 'OrderSignature',
            component: OrderSignature,
            meta: {
                requiresAuth: false
            },
        },
        {
            path: '/admin',
            name: 'admin',
            component: Admin,
            meta: {
                requiresAuth: true,
            },
            children: [
                {
                    path: 'dashboard',
                    name: 'dashboard',
                    component: Dashboard,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'profile',
                    name: 'profile',
                    component: Profile,
                    meta: {
                        requiresAuth: true,
                    },
                },

                // quotations
                {
                    path: 'quotations',
                    name: 'quotations',
                    component: Quotations,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'quotations/add',
                    name: 'addQuotePage',
                    component: NewQuotation,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'quotations/view/:id',
                    name: 'viewQuote',
                    component: QuotationShow,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'quotation/price_calculation/:id/:version?',
                    name: 'PriceCalculationPage',
                    component: PriceCalculation,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'quotation/send_quote_customer/:id',
                    name: 'SendToCustomerPage',
                    component: SendQuoteCustomer,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'quotations/view_quote/:id',
                    name: 'ViewCustomerQuote',
                    component: QuoteSentCustomer,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'quotations/draft',
                    name: 'draft',
                    component: DraftQuotation,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'quotation_task/add',
                    name: 'addTask',
                    component: DraftQuotation,
                    meta: {
                        requiresAuth: true,
                    },
                },

                //customers
                {
                    path: 'customers',
                    name: 'viewCustomers',
                    component: CustomerList,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'customers/view/:id',
                    name: 'customerDetails',
                    component: CustomerView,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'customers/add',
                    name: 'addCustomer',
                    component: CustomerAdd,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'customers/edit/:id',
                    name: 'editCustomer',
                    component: CustomerEdit,
                    meta: {
                        requiresAuth: true,
                    },
                },

                //customers
                {
                    path: 'warehouse',
                    name: 'viewWarehouse',
                    component: WarehouseList,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'warehouse/edit/:id',
                    name: 'editWarehouse',
                    component: WarehouseEdit,
                    meta: {
                        requiresAuth: true,
                    },
                },

    
                //vendors
                {
                    path: 'vendors',
                    name: 'viewVendors',
                    component: VendorList,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'vendors/view/:id',
                    name: 'vendorDetails',
                    component: VendorView,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'vendors/add',
                    name: 'addVendor',
                    component: VendorAdd,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'vendors/edit/:id',
                    name: 'editVendor',
                    component: VendorEdit,
                    meta: {
                        requiresAuth: true,
                    },
                },

                //Task Route
                {
                    path: 'tasks',
                    name: 'tasks',
                    component: Tasks,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'reminders',
                    name: 'reminders',
                    component: Reminders,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'quotation_tasks',
                    name: 'viewTasks',
                    component: TaskList,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'vendors/quotation_task/:id',
                    name: 'taskDetails',
                    component: TaskView,
                    meta: {
                        requiresAuth: true,
                    },
                },
                // {
                //     path: 'quotation_task/add',
                //     name: 'addTask',
                //     component: TaskAdd,
                //     meta: {
                //         requiresAuth: true,
                //     },
                // },
                {
                    path: 'quotation_task/edit/:id',
                    name: 'taskEdit',
                    component: TaskEdit,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'quotation_task/view/:id',
                    name: 'taskView',
                    component: TaskView,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'task-workflows',
                    name: 'taskWorkflows',
                    component: TaskWorkflows,
                    meta: {
                        requiresAuth: true,
                    },
                },
                // settings
                {
                    path: 'users',
                    name: 'viewUsers',
                    component: UserList,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'users/permission/:id',
                    name: 'userPermission',
                    component: UserPermission,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'task_priority',
                    name: 'viewTasksPriority',
                    component: TaskPriority,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'user_roles',
                    name: 'userRoles',
                    component: UserRole,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'labels',
                    name: 'labels',
                    component: Labels,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'quotation_status',
                    name: 'quotaionStatus',
                    component: QuotationStatus,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'quotation_status/add',
                    name: 'addQuotaionStatus',
                    component: QuotationStatusAdd,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'quotation_status/edit/:id',
                    name: 'editQuotaionStatus',
                    component: QuotationStatusEdit,
                    meta: {
                        requiresAuth: true,
                    },
                },

                {
                    path: 'sales_rep',
                    name: 'salesRep',
                    component: SalesRep,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'sales_rep/add',
                    name: 'addSalesRep',
                    component: SalesRepAdd,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'quotation_status/edit/:id',
                    name: 'editSalesRep',
                    component: SalesRepEdit,
                    meta: {
                        requiresAuth: true,
                    },
                },

                {
                    path: 'vendor_bags',
                    name: 'viewBagList',
                    component: VendorBag,
                    meta: {
                        requiresAuth: true,
                    },
                },
                 {
                    path: 'vendor_bags/add',
                    name: 'addVendorBags',
                    component: VendorBagAdd,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'vendor_bags/edit/:id',
                    name: 'editVendorBags',
                    component: VendorBagEdit,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'global_settings',
                    name: 'globalSetting',
                    component: GlobalSettings,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'default_settings',
                    name: 'defaultSetting',
                    component: DefaultGlobalSettings,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'notification_settings',
                    name: 'notification_settings',
                    component: NotificationSettings,
                    meta: {
                        requiresAuth: true,
                    },
                },

                // Orders
                {
                    path: 'orders',
                    name: 'orders',
                    component: Orders,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'orders/draft',
                    name: 'draft.orders',
                    component: DraftOrders,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'orders/create',
                    name: 'addOrderPage',
                    component: AddOrder,
                    meta: {
                        requiresAuth: true,
                    },
                    children:[
                        {
                            path: '',
                            name: 'selectCustomer',
                            component: SelectCustomer,
                            meta: {
                                requiresAuth: true,
                            },
                        },
                        {
                            path: 'select-quotes',
                            name: 'selectQuotes',
                            component: SelectQuotes,
                            meta: {
                                requiresAuth: true,
                            },
                        },
                        {
                            path: 'select-products',
                            name: 'selectProducts',
                            component: SelectProducts,
                            meta: {
                                requiresAuth: true,
                            },
                        },
                        {
                            path: 'other-info',
                            name: 'provideOtherInfo',
                            component: ProvideOtherInfo,
                            meta: {
                                requiresAuth: true,
                            },
                        },
                    ]
                },
                {
                    path: 'orders/:id/edit',
                    name: 'editOrderPage',
                    component: AddOrder,
                    meta: {
                        requiresAuth: true,
                    },
                    children:[
                        {
                            path: '',
                            name: 'editSelectCustomer',
                            component: SelectCustomer,
                            meta: {
                                requiresAuth: true,
                            },
                        },
                        {
                            path: 'select-quotes',
                            name: 'editSelectQuotes',
                            component: SelectQuotes,
                            meta: {
                                requiresAuth: true,
                            },
                        },
                        {
                            path: 'select-products',
                            name: 'editSelectProducts',
                            component: SelectProducts,
                            meta: {
                                requiresAuth: true,
                            },
                        },
                        {
                            path: 'other-info',
                            name: 'editProvideOtherInfo',
                            component: ProvideOtherInfo,
                            meta: {
                                requiresAuth: true,
                            },
                        },
                    ]
                },
                {
                    path: 'orders/view/:id',
                    name: 'orderShow',
                    component: Order,
                    meta: {
                        requiresAuth: true,
                    },
                },


                // Purchase Orders
                {
                    path: 'purchase-orders',
                    name: 'purchaseOrders',
                    component: PurchaseOrders,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'purchase-orders/draft',
                    name: 'draft.purchaseOrders',
                    component: DraftPurchaseOrders,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'purchase-orders/create',
                    name: 'addPurchaseOrderPage',
                    component: AddPurchaseOrder,
                    meta: {
                        requiresAuth: true,
                    },
                    children:[
                        {
                            path: '',
                            name: 'purchaseSelectProducts',
                            component: PurchaseSelectProducts,
                            meta: {
                                requiresAuth: true,
                            },
                        },
                        {
                            path: 'select-vendor',
                            name: 'purchaseSelectVendor',
                            component: PurchaseSelectVendor,
                            meta: {
                                requiresAuth: true,
                            },
                        },
                        {
                            path: 'other-info',
                            name: 'purchaseProvideOtherInfo',
                            component: PurchaseProvideOtherInfo,
                            meta: {
                                requiresAuth: true,
                            },
                        },
                    ]
                },
                {
                    path: 'purchase-orders/view/:id',
                    name: 'purchaseOrderShow',
                    component: PurchaseOrderShow,
                    meta: {
                        requiresAuth: true,
                    },
                },

                 {
                    path: 'purchase-orders/shipment/:id/:shipId',
                    name: 'purchaseOrderShowShipment',
                    component: purchaseOrderShowShipment,
                    meta: {
                        requiresAuth: true,
                    },
                },

                                //products
                {
                    path: 'products',
                    name: 'viewProducts',
                    component: ProductsList,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'products/view/:id',
                    name: 'productsDetails',
                    component: ProductsView,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'products/add',
                    name: 'addProducts',
                    component: ProductsAdd,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'products/edit/:id',
                    name: 'editProducts',
                    component: ProductsEdit,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'reports/sales-order',
                    name: 'reportsSO',
                    component: SalesReport,
                    meta: {
                        requiresAuth: true,
                    },
                },
                 {
                    path: 'reports/purchase-order',
                    name: 'reportsPO',
                    component: SalesReport,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'shipments',
                    name: 'shipments',
                    component: Shipments,
                    meta: {
                        requiresAuth: true,
                    },
                },

            ]
        },

    ];
}




